export const SET_CHANNEL = 'SESSION/SET_CHANNEL'
export const SET_OFFERS = 'SESSION/SET_OFFERS'
export const SET_STACKED_OFFERS = 'SESSION/SET_STACKED_OFFERS'
export const SET_VISITOR = 'SESSION/SET_VISITOR'
export const SET_PAGE = 'SESSION/SET_PAGE'
export const SET_COMPONENT =  'SESSION/SET_COMPONENT'
export const SET_CURRENT_PAGE =  'SESSION/SET_CURRENT_PAGE'


// WEBPACK FOOTER //
// ./src/store/modules/session/mutations.js